import { Form } from 'util/ui'
import { css } from '@emotion/react'
import themeVars from 'ui_theme/site/globals/site.variables'

// HACK (jscheel): This button is a bit of a styling hack until we can get our
// design framework back in line with our design library.
const buttonStyle = () => theme => css`
  & button {
    font-family: ${theme.font.primary} !important;
    font-size: ${theme.spacing['10']} !important;
    font-weight: ${theme.fontWeight.medium} !important;
    line-height: ${theme.lineHeight.leadingNone} !important;
    padding-top: ${themeVars.relative15px} !important;
    padding-bottom: ${themeVars.relative15px} !important;
  }
`

const Button = props => {
  return <Form.Button primary size="big" fluid css={buttonStyle} {...props} />
}

export default Button
